import React from 'react';
import PropTypes from 'prop-types';
import errorBoundary from '@ifeng-fe/errorBoundary';
import { Swiper, SwiperSlide } from 'swiper/react';
import { Navigation, Pagination, Keyboard } from 'swiper';
import { formatImageWebpAuto } from '@ifeng-fe/public_method';
import 'swiper/css';
import Style from './index.css';
import tbc from './tbc.png';

const Page2 = (props) => {
    const { peopleList, onChangeMaskVisible, onChangeCurrentVideo, peopleIndex, onChangePeopleIndex } = props;

    const openVideo = (video) => {
        onChangeCurrentVideo({
            url: video.videoUrl,
            duration: video.videoDuration,
            guid: video.videoGuid,
        });
        onChangeMaskVisible(true);
    };

    const hasVideoList = Array.isArray(peopleList[peopleIndex]?.videoList) && peopleList[peopleIndex]?.videoList.length;

    return (
        <div className={Style.page2}>
            {hasVideoList ? (
                <>
                    <div className={Style.swiperWp}>
                        <img className={Style.navigation} id="page2_prev" src="https://x0.ifengimg.com/ucms/2025_21/D5615076AC196A1F638BEDA9F550727282ED49C8_size3_w69_h126.png" alt="" />

                        <Swiper
                            key={peopleIndex}
                            modules={[Navigation, Pagination, Keyboard]}
                            className={Style.swiper}
                            slidesPerView={3}
                            slidesPerGroup={3}
                            speed={1500}
                            loop={true}
                            navigation={{
                                prevEl: '#page2_prev',
                                nextEl: '#page2_next',
                            }}
                            pagination={{
                                el: `.${Style.pagination}`,
                                type: 'fraction',
                            }}
                            keyboard={{
                                enabled: true,
                            }}>
                            {peopleList[peopleIndex]?.videoList.map((video, index) => {
                                return (
                                    <SwiperSlide key={index}>
                                        <div className={Style.swiperItem} onClick={() => openVideo(video)}>
                                            <div className={Style.video}>
                                                <img className={Style.poster} src={formatImageWebpAuto(video.poster, 450, 244)} alt="" />
                                                <div className={Style.mask}>
                                                    <img className={Style.play} src="https://x0.ifengimg.com/ucms/2025_21/0A2F103450BD2F525D4E54E5D0AA040074F95A3C_size2_w63_h63.png" alt="" />
                                                </div>
                                            </div>
                                            <div className={Style.title}>
                                                <div className={Style.titleText}>{video.title}</div>
                                            </div>
                                        </div>
                                    </SwiperSlide>
                                );
                            })}
                        </Swiper>

                        <img className={Style.navigation} id="page2_next" src="https://x0.ifengimg.com/ucms/2025_21/608518DB1E90E8549D01DC6B5437D960AC8BF52D_size3_w68_h126.png" alt="" />
                    </div>

                    <div className={Style.pagination} />
                </>
            ) : (
                <div className={Style.swiperEmpty}>
                    <img src={tbc} alt="" />
                </div>
            )}

            <div className={Style.peopleList}>
                {peopleList.map((people, index) => {
                    return (
                        <div key={index}>
                            <div className={`${Style.people} ${index === peopleIndex ? Style.active : ''}`} onClick={() => onChangePeopleIndex(index)}>
                                {people.name}
                            </div>
                            {index < peopleList.length - 1 && <span className={Style.divider}>/</span>}
                        </div>
                    );
                })}
            </div>
        </div>
    );
};

Page2.propTypes = {
    peopleList: PropTypes.array,
    onChangeMaskVisible: PropTypes.func,
    onChangeCurrentVideo: PropTypes.func,
    peopleIndex: PropTypes.number,
    onChangePeopleIndex: PropTypes.func,
};

export default errorBoundary(Page2);
